import { html, nothing, render } from "lit-html";
import connect from "@escapio/shared/data-store/connect";
import { removeInitialContent } from "@escapio/shared/components/element-builder";
import { store } from "./DataStore";
import { translate } from "@escapio/shared/l10n/translate";
import { data } from "@escapio/shared/state/payload";
import { travelData } from "@escapio/portal/state/travelData";
import { getFormatter } from "@escapio/shared/l10n/currency";
import { getDirectLinkWithTravelData } from "../get-direct-link-with-traveldata";
import { hasDirectLink } from "@escapio/portal/state/DirectLink";
import { trackDirectLink } from "../../tracker/Clickout";

const { hotel } = data;
const HAS_DIRECT_LINK = hasDirectLink(hotel);

customElements.define(
	"esc-profile-direct-link-box",
	class extends connect(removeInitialContent(HTMLElement), store) {
		update(state) {
			render(this.getTemplate(state), this, { host: this });
		}

		getTemplate(state) {
			const bestPrice = state?.prices?.bestPrice;
			const priceStr = bestPrice
				? this.priceFormat(
						bestPrice / travelData.nights / travelData.rooms.length,
					)
				: null;

			return html`<div class="price-comparer_direct-link-box">
				<div class="price-comparer_direct-link-box__header-row">
					<div class="price-comparer_direct-link-box__header">
						${translate("hotel_direct_link_book")}
					</div>
					${
						priceStr
							? html`<div class="price-comparer_direct-link-box__price">
									<small>${translate("basic_from")}</small>
									${priceStr}
									<small
										>${translate("hotel_escapio_offer_price_hint_min_price")}</small
									>
								</div>`
							: nothing
					}
				</div>
				<div class="price-comparer_direct-link-box__hotel-name">
					${hotel.name}
				</div>
				<ul class="price-comparer_direct-link-box__benefits">
					<li>${translate("hotel_direct_link_benefit_1")}</li>
					<li>${translate("hotel_direct_link_benefit_2")}</li>
				</ul>
				<a
					class="action-button price-comparer_direct-link-box__cta"
					href=${this.directLink}
					target="_blank"
					rel="nofollow noopener"
					@click=${() => {
						trackDirectLink("Hotelprofil", hotel, undefined);
					}}
				>
					${translate("hotel_direct_link_website")}
				</a>
			</div>`;
		}

		get directLink() {
			return HAS_DIRECT_LINK
				? getDirectLinkWithTravelData(hotel.direct_link)
				: null;
		}

		get priceFormat() {
			return getFormatter(travelData.currency);
		}
	},
);
